<template>
  <ctas :hide-ctas-on-mobile="!$feature.tempVansNewNav.value" />
</template>

<script lang="ts" setup>
import Ctas from '#brand/components/pdp/section/Ctas.vue'
</script>
